import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface ShipnityCreateRequestParams {
  shopId: number;
  shopName: string;
  email: string;
  token: string;
  mcApiKey: string;
  mcSecretkey: string;
  stockIdValue: number | null;
}

export interface ShipnityUpdateRequestParams {
  shopName: string;
  email: string;
  token: string;
  mcApiKey: string;
  mcSecretkey: string;
  stockIdValue: number | null;
}

export class ShipnityClient {
  constructor(private httpClient: HTTPClient) {}

  public async postShipnity(params: ShipnityCreateRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shops-shipnity",
      method: "POST",
      data: params
    });

    return data;
  }

  public async getShipnity(params: PaginationRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shops-shipnity",
      method: "GET",
      params
    });

    return data;
  }

  public async getShipnityById(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-shipnity/${id}`,
      method: "GET"
    });

    return data;
  }

  public async patchShipnity(
    id: number,
    params: ShipnityUpdateRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-shipnity/${id}`,
      method: "PATCH",
      data: params
    });

    return data;
  }

  public async deleteShipnity(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-shipnity/${id}`,
      method: "DELETE"
    });

    return data;
  }

  public async postShipnityProductSyncByShopId(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shipnity/shop/${id}/product/sync`,
      method: "POST"
    });

    return data;
  }

  public async postShipnityStockSyncByShopId(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shipnity/shop/${id}/stock/sync`,
      method: "POST"
    });

    return data;
  }
}
